import React from "react";
import { FormCard } from "@/components/FormCard";
import { PreviewDeviceTabs, PreviewPlayerField, UrlField } from "../../components/PreviewControlFields";
import { PreviewPlayerState } from "../../components/usePreviewPlayer";

interface Props {
  preview: PreviewPlayerState;
  pageUrl: string;
  isSamplePreview: boolean;
}

const ReviewPagePreviewControls: React.FC<Props> = ({ preview, pageUrl, isSamplePreview }) => (
  <FormCard>
    <FormCard.Header title="Preview Controls" description="These options only update the preview and links." />

    <FormCard.Content>
      <PreviewDeviceTabs value={preview.previewDevice} onChange={preview.setPreviewDevice} />
      <PreviewPlayerField players={preview.players} />
      <UrlField label="Page URL" url={pageUrl} canOpen={!isSamplePreview} />
    </FormCard.Content>
  </FormCard>
);

export { ReviewPagePreviewControls };
